var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { ButtonPrimary, ButtonSecondary, ButtonTertiary, } from '@spotify-internal/encore-web/core';
import { useS4AMastheadContext } from '../../S4AMastheadProvider';
const createButtonLink = (ButtonComponent) => {
    const ButtonLink = (_a) => {
        var { label, href, openInNewTab, trackingCategory, trackingLabel } = _a, rest = __rest(_a, ["label", "href", "openInNewTab", "trackingCategory", "trackingLabel"]);
        const { getLinkProps } = useS4AMastheadContext();
        const props = getLinkProps({
            trackingAttributes: [trackingCategory, trackingLabel, 'click'],
            href: href,
            openInNewTab: openInNewTab,
        });
        return (React.createElement(ButtonComponent, Object.assign({}, props, rest), label));
    };
    return ButtonLink;
};
export const ButtonPrimaryLink = createButtonLink(ButtonPrimary);
export const ButtonSecondaryLink = createButtonLink(ButtonSecondary);
export const ButtonTertiaryLink = createButtonLink(ButtonTertiary);
//# sourceMappingURL=index.js.map